<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
    </div>
    <div class="table-operator">
      <!-- <a-button type="primary" icon="plus" @click="handleAdd" >新建</a-button> -->
    </div>
    <template>
      主动申请考级中心考级点各省统计
      <div id="Map" ref="myEchart"></div>

    </template>
      

  </a-card>
</template>
<style scoped>
#Map {
  width: 100%;
  height: 600px;
}

</style>
<script> 
  import { provinceMapData  } from '@/api/qcxj'   

  const echarts = require("echarts")
//  import echarts from "echarts/dist/echarts";
  // Vue.prototype.$echarts = echarts
   import china from '@/assets/json/china.json'  //此处填上面内容创建的china.json文件的路径
//   Vue.prototype.$echarts = echarts
//   console.log('echarts',echarts);
  echarts.registerMap('china', china)

  export default {
    name: 'CityList',
    components: { 
    },
    data () {
      return { 
//        description: '全校班级管理。',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        }, 
        mdl: {},
        list:[],
 
      }
    },
    created () {
//      getRoleList({ t: new Date()})
    },
    computed:{ 
    },
    mounted(){
      let that = this;
      that.fetch();


      
    },
    methods: {
      fetch(){
        let that = this;
        that.saveLoading =true;
        provinceMapData()
                .then(res => {
                  that.list =  res.data 
                  that.init()
                })
      }, 
      sortBy(field) {
        return function (a, b) {
          return b[field] - a[field];
        };
      },

      init(){
        var chart = echarts.init(this.$refs.myEchart);
          
          let maxArr = this.list.sort(this.sortBy('value'));//sortBy是根据value字段对对象数组进行排序
          console.log('maxArr', maxArr);
          var option = {
            backgroundColor: '#fff', //画布背景颜色
            tooltip: {
              show: true,
              trigger: 'item',
              formatter: (data) => {
                return `<h3>${data}</h3>`;
              },
              data: maxArr,
            },
            visualMap: {
              min: 0,
              max: maxArr[0].value,
              text: ['高', '低'],
              realtime: false,
              calculable: true,
              inRange: {
                color: ['#8dc1f1', '#0e31a4'],
              },
              textStyle: {
                color: '#333',
              },
              left: 20,
              bottom: 10,
            },
            // geo: {
            //   map: 'china',
            //   //   roam: true,
            //   zoom: 1.2,
            //   viewControl: {
            //     rotateSensitivity: 0, //禁止旋转地图
            //     //下面的四个参数 可以实现禁止缩放地图
            //     projection: 'orthographic',
            //     orthographicSize: 110,
            //     maxOrthographicSize: 110,
            //     minOrthographicSize: 110,
            //   },
            //   label: {
            //     normal: {
            //       show: false,
            //       textStyle: {
            //         color: 'rgba(0,0,0,0.4)',
            //       },
            //     },
            //   },
            //   itemStyle: {
            //     normal: {
            //       borderColor: '#999',
            //       shadowColor: '#f90',
            //     },
            //     emphasis: {
            //       show: true,
            //       areaColor: '#f90',
            //       label: {
            //         show: true,
            //       },
            //       shadowOffsetX: 0,
            //       shadowOffsetY: 0,
            //       shadowBlur: 20,
            //       borderWidth: 0,
            //       shadowColor: 'rgba(0, 0, 0, 0.5)',
            //     },
            //   },
            // },
            series: [
              {
                name: '浏览量',
                type: 'map',
                map: 'china',
                roam: true,
                // coordinateSystem: 'geo',
                geoIndex: 0,
                tooltip: { show: false },
                label: {
                  normal: {
                    formatter: '{b}\r\n{c}',
                    position: 'right',
                    show: true,
                  },
                  emphasis: {
                    show: true,
                  },
                },
                data: maxArr,
              },
            ],
          };
          chart.setOption(option); 

      }

    },
    watch: {
      /*
       'selectedRows': function (selectedRows) {
       this.needTotalList = this.needTotalList.map(item => {
       return {
       ...item,
       total: selectedRows.reduce( (sum, val) => {
       return sum + val[item.dataIndex]
       }, 0)
       }
       })
       }
       */
    }
  }
</script>
